import { Box, Typography, styled } from '@mui/material';
import { useCartContext } from '../../cart-context';
import { getCatalogItemPriceMetadata } from '../../lib/catalog-item/get-catalog-item-price-metadata';
import Title from '../shared/title';
import ItemPrice from './item-price';

const FinePrint = styled(Typography)(({ theme }) => ({
  fontSize: '11px',
  color: theme.palette.text.primary,
  marginTop: '0.5rem',
  marginBottom: '0.5rem',
}));

function CartTotal() {
  const {
    cartState: { catalogItem: item, cartJurisdictionId, cartPrice },
  } = useCartContext();

  const { itemPriceDuration, price, currencyCode, originalPrice } = getCatalogItemPriceMetadata({
    cartJurisdictionId,
    cartPrice,
    item,
  });

  return (
    <Box marginTop={2}>
      <Title sx={{ fontSize: '24px' }} variant="h2">
        Total:
      </Title>
      <ItemPrice
        currencyCode={currencyCode}
        duration={itemPriceDuration}
        originalPrice={originalPrice}
        priceCents={price}
      />
      <FinePrint>
        Recurring monthly charge. Payment will be charged to the payment method provided. Your
        membership will automatically renew each month starting the day of purchase.
      </FinePrint>
    </Box>
  );
}

export default CartTotal;
